import React from "react";
import Skeleton from "./elementalUI/skeleton/Skeleton";
import { getTaskGridColumns } from "./taskGridColumns";

const DEFAULT_ROW_COUNT = 10;

const TaskGridSkeleton = ({
  isShowActualTime = false,
  isShowRemainingTime = false,
  isGrouped = false,
  rowCount = DEFAULT_ROW_COUNT,
}) => {
  const columns = getTaskGridColumns(isShowActualTime, isShowRemainingTime);

  const renderCellPlaceholder = (column) => {
    if (column.key === "checkbox") {
      return <Skeleton width="14px" height="14px" />;
    }

    if (column.key === "assignee") {
      return <Skeleton width="25px" height="25px" shape="circle" />;
    }

    return <Skeleton width={column.skeletonWidth} height="16px" />;
  };

  return (
    <div className="task-grid-container is-loading" aria-busy="true">
      <div className="task-grid-scroll">
        <div className="expand-collapse-btn-container">
          <div className="task-grid-toolbar-row">
            <div className="task-grid-toolbar-left">
              <div className="task-grid-result-count">
                <Skeleton width="120px" height="14px" />
              </div>
              <Skeleton width="104px" height="30px" className="skeleton-pill" />
              <Skeleton width="240px" height="30px" className="skeleton-pill" />
            </div>
            <div className="expand-collapse-btn-actions">
              <Skeleton width="88px" height="34px" className="skeleton-pill" />
              <Skeleton width="34px" height="34px" shape="circle" />
              {isGrouped && (
                <Skeleton width="112px" height="34px" className="skeleton-pill" />
              )}
            </div>
          </div>
          <div className="task-grid-toolbar-row task-grid-toolbar-row--stats">
            <div className="group-stats">
              <Skeleton width="96px" height="26px" className="skeleton-pill" />
              <Skeleton width="84px" height="26px" className="skeleton-pill" />
              <Skeleton width="84px" height="26px" className="skeleton-pill" />
            </div>
          </div>
        </div>

        <div className="task-group">
          <table className="task-table skeleton-loader">
            <thead>
              <tr>
                {columns.map((column) => (
                  <th key={column.key} className={column.className}>
                    {column.key === "checkbox" ? renderCellPlaceholder(column) : column.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {Array.from({ length: rowCount }).map((_, rowIndex) => (
                <tr key={rowIndex}>
                  {columns.map((column) => (
                    <td key={column.key} className={column.className}>
                      {renderCellPlaceholder(column)}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default TaskGridSkeleton;
